import { render, staticRenderFns } from "./bannerForm.vue?vue&type=template&id=1bf54d30&scoped=true&"
import script from "./bannerForm.vue?vue&type=script&lang=js&"
export * from "./bannerForm.vue?vue&type=script&lang=js&"
import style0 from "./bannerForm.vue?vue&type=style&index=0&id=1bf54d30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf54d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf54d30')) {
      api.createRecord('1bf54d30', component.options)
    } else {
      api.reload('1bf54d30', component.options)
    }
    module.hot.accept("./bannerForm.vue?vue&type=template&id=1bf54d30&scoped=true&", function () {
      api.rerender('1bf54d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/business/components/bannerForm.vue"
export default component.exports